export const environment = {
  production: false,
  apiUrl: 'https://f6h28yn1v2.execute-api.ap-southeast-4.amazonaws.com',
  socketUrl: 'https://f6h28yn1v2.execute-api.ap-southeast-4.amazonaws.com',
  embedBaseUrl: 'https://pgp-dev-01.theqadimgroup.com.au',
};
